/**
 * 私桩共享订单状态 (02-待预付; 03-待使用; 04-使用中; 05-待支付; 06-交易完成; 07-待评价; 08-退款中; 09-交易关闭; 10-结算中; 11-待结算)
 */
export enum OrderStatusEnum {
  WAIT_PREPAY = "02",
  TO_BE_USED = "03",
  USING = "04",
  WAIT_PAY = "05",
  FINISHED = "06",
  WAIT_EVALUATE = "07",
  REFUNDING = "08",
  CLOSED = "09",
  SETTLEMENT = "10",
  TO_BE_SETTLED = "11"
}

/**
 * 到账状态,0-未到账,1-已到账
 */
export enum ReceiptStatusEnum {
  UNRECEIPTED = 0,
  RECEIPTED = 1
}

/**
 * 结算方式 (01-个人; 02-集团; 03-集团; 04-线下)
 */
export enum SettleTypeEnum {
  PERSONAL = "01",
  GROUP = "02",
  COMPANY = "03",
  OFFLINE = "04"
}

/**
 * 订单文案及样式
 */
export const titleEnums = {
  // 线下支付
  OFFLINE: {
    color: "rgba(0, 0, 0, 0.4)",
    title: "线下支付"
  },
  WAIT_PAY: {
    color: "#F58900",
    title: "待使用者支付"
  },
  TRADE_SUCCESS: {
    color: "rgba(0, 0, 0, 0.4)",
    title: "到账中"
  },
  RECEIPTED: {
    color: "#5A960A",
    title: "已到账"
  }
};

export const shareGuideTextList = [
  '空空如也，赶快邀请吧',
  '运营小Tips：分享到业主群能更好提升收益',
  '运营小Tips：分享到朋友圈会有意外收益',
  '运营小Tips：小手微微一点，收益速速达成',
  '伟大的鹏友，赶紧分享到朋友圈让更多人知道吧',
  '快让更多人知道，开启你收益的第一步'
]